import { render, staticRenderFns } from "./PageAdminTaskTemplates.vue?vue&type=template&id=b0f13b68"
import script from "./PageAdminTaskTemplates.vue?vue&type=script&lang=js"
export * from "./PageAdminTaskTemplates.vue?vue&type=script&lang=js"
import style0 from "./PageAdminTaskTemplates.vue?vue&type=style&index=0&id=b0f13b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports